<template>
  <div class="container my-md-5 my-0">
    <div class="tab-content">
      <div class="tab-pane fade show active">
        <div class="tab-content">
          <div
            class="tab-pane fade"
            v-bind:class="{
                            show: this.page === 'profile',
                            active: this.page === 'profile'
                        }"
          >
            <user-profile @onClick="changePage('remote-readiness')"></user-profile>
          </div>
          <div
            class="tab-pane fade"
            v-bind:class="{
                            show: this.page === 'remote-readiness',
                            active: this.page === 'remote-readiness'
                        }"
          >
            <setup-remote-readiness @onClick="changePage('profile')"></setup-remote-readiness>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: "profile"
    };
  },

  methods: {
    changePage(page) {
      this.page = page;
    }
  },

  mounted() {
    if (window.location.hash.substr(1)) {
      this.page = window.location.hash.substr(1);
    }
  }
};
</script>

<style scoped></style>
